import React from 'react'
import { Box, Typography } from '@mui/material'
import { Control, Controller } from 'react-hook-form'

import { Input } from '../../../../interaxDesignSystemComponents'
import { INTERAX_COLORS } from '../../../../constants/colors'

export type UserRowValues = {
  name: string
  email: string
}

export type InviteUsersFormValues = UserRowValues

type UserRowErrors = {
  name?: string
  email?: string
}

interface LabelsConfig {
  name: string
  email: string
  namePlaceholder: string
  emailPlaceholder: string
}

interface InviteUserRowProps {
  control: Control<InviteUsersFormValues>
  labels: LabelsConfig
  errors?: UserRowErrors
  autoFocus?: boolean
}

export const InviteUserRow: React.FC<InviteUserRowProps> = ({ control, labels, errors, autoFocus }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        padding: '16px',
        borderRadius: '12px',
        backgroundColor: 'rgba(7, 13, 20, 0.6)',
        border: `1px solid ${INTERAX_COLORS.heritageBlue}`
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Box>
          <Typography
            sx={{ fontSize: '12px', fontWeight: 500, color: INTERAX_COLORS.thunderGrey, marginBottom: '6px' }}
          >
            {labels.name}
          </Typography>
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <Input
                value={field.value || ''}
                onChange={(event) => field.onChange(event.target.value)}
                placeholder={labels.namePlaceholder}
                fullWidth
                autoFocus={autoFocus}
                error={!!errors?.name}
                errorMessage={errors?.name}
              />
            )}
          />
        </Box>

        <Box>
          <Typography
            sx={{ fontSize: '12px', fontWeight: 500, color: INTERAX_COLORS.thunderGrey, marginBottom: '6px' }}
          >
            {labels.email}
          </Typography>
          <Controller
            control={control}
            name="email"
            render={({ field }) => (
              <Input
                value={field.value || ''}
                onChange={(event) => field.onChange(event.target.value)}
                placeholder={labels.emailPlaceholder}
                fullWidth
                type="email"
                error={!!errors?.email}
                errorMessage={errors?.email}
              />
            )}
          />
        </Box>
      </Box>
    </Box>
  )
}
